import { useEffect, useState, useCallback } from 'react'
import { Link } from "react-router-dom";

export default function ModularHeader() {
  const [isSticky, setIsSticky] = useState(false);

  const handleScroll = useCallback(() => {
    const heightFromTop = window.scrollY;
    setIsSticky(heightFromTop > 0);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <>
      <header className={`modularheader-area ${isSticky ? 'modularstick' : ''}`}>
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-3 col-md-3 col-4">
              <div className="modular-logo">
                <Link to={"/"}><img src="/image/logo.webp" alt="Logo" /></Link>
              </div>
            </div>

          </div>
        </div>
      </header>
    </>
  )
}
